import React from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialFeatured } from './components/TestimonialFeatured';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
import { CerebroDigital } from './components/CerebroDigital';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-green-500/30 font-sans overflow-x-hidden space-y-[0px]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialFeatured data-id="element-3" />
      <PainSection data-id="element-4" />

      <div className="bg-gradient-to-b from-[#0a0a0a] via-gray-900/20 to-[#0a0a0a]" data-id="element-5">
        <ProductReveal data-id="element-6" />
        <TomosSection data-id="element-7" />

        <div className="max-w-3xl mx-auto px-4 py-6" data-id="element-8">
          <div className="bg-green-900/10 border border-green-500/20 rounded-2xl p-5 md:p-6" data-id="element-9">
            <h3 className="text-xl font-bold text-green-400 mb-4 flex items-center gap-2" data-id="element-10">
              <span className="text-2xl" data-id="element-11">✅</span> Todo incluye:
            </h3>
            <ul className="space-y-3" data-id="element-12">
              {['Formularios imprimibles y digitales', 'Protocolos basados en evidencia actualizada', 'Adaptado 100% al contexto argentino 2025', 'Normativa argentina vigente (Leyes 26.529 · 27.642)', 'Listo para usar desde la primera consulta'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-13">
                  <span className="text-green-500 mt-1" data-id="element-14">✓</span> {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <BonusSection data-id="element-15" />
      <CountdownTimer data-id="element-16" />
      <PricingCards data-id="element-17" />
      <CerebroDigital data-id="element-18" />
      <TestimonialsSection data-id="element-19" />
      <GuaranteeSection data-id="element-20" />
      <FAQSection data-id="element-21" />
      <CostSection data-id="element-22" />
      <FinalCTA data-id="element-23" />
      <Footer data-id="element-24" />
      <SocialProofToast data-id="element-25" />
    </div>;
}